import React from 'react';
import { Button, ButtonProps } from '@mui/material';

export const CMButton: React.FC<ButtonProps> = ({ 
  children, 
  sx,
  variant = "contained",
  ...props 
}) => {
  return (
    <Button
      variant={variant}
      {...props}
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        padding: '8px 16px',
        borderRadius: '4px',
        textTransform: 'none',
        minHeight: '36px',
        fontFamily: 'inherit',
        fontSize: '0.875rem',
        fontWeight: 500,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.9)',
        '&:hover': {
          backgroundColor: 'primary.dark',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        },
        '&.Mui-disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          color: 'rgba(0, 0, 0, 0.26)',
          boxShadow: 'none',
        },
        transition: 'all 0.2s ease-in-out',
        ...sx
      }}
    >
      {children}
    </Button>
  );
}; 